var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37319 14.38C8.26439 14.4581 8.13381 14.5002 7.99985 14.5002C7.8659 14.5002 7.73532 14.4581 7.62652 14.38C4.40719 12.0853 0.99052 7.36533 4.44452 3.95467C5.39275 3.0219 6.66974 2.49942 7.99985 2.5C9.33319 2.5 10.6125 3.02333 11.5552 3.954C15.0092 7.36467 11.5925 12.084 8.37319 14.38Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 8.49992C8.35346 8.49992 8.6926 8.35944 8.94265 8.10939C9.19269 7.85935 9.33317 7.52021 9.33317 7.16659C9.33317 6.81296 9.19269 6.47382 8.94265 6.22378C8.6926 5.97373 8.35346 5.83325 7.99984 5.83325C7.64622 5.83325 7.30708 5.97373 7.05703 6.22378C6.80698 6.47382 6.6665 6.81296 6.6665 7.16659C6.6665 7.52021 6.80698 7.85935 7.05703 8.10939C7.30708 8.35944 7.64622 8.49992 7.99984 8.49992Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6e6beb4e4590c015f26ef0da371a19b5.svg";
export { ForwardRef as ReactComponent };